import { createBrowserRouter, Navigate } from 'react-router-dom'

import CardRegisterCallbackPage from '@/pages/CardRegisterCallbackPage/page'
import CardRegisterPage from '@/pages/CardRegisterPage/page'
import DebugPage from '@/pages/DebugPage/page'
import SealedVinylPage from '@/pages/SealedVinylPage/page'
import SealedVinylProcessPage from '@/pages/SealedVinylProcessPage/page'
import SealedVinylResultPage from '@/pages/SealedVinylResultPage/page'

import { ROUTES } from './routes'

const router = createBrowserRouter([
  {
    path: ROUTES.ROOT,
    element: (
      <Navigate
        to={ROUTES.SEALED_VINYL}
        replace
      />
    ),
  },
  {
    path: ROUTES.DEBUG,
    element: <DebugPage />,
  },
  {
    path: ROUTES.SEALED_VINYL,
    element: <SealedVinylPage />,
  },
  {
    path: ROUTES.SEALED_VINYL_PROCESS,
    element: <SealedVinylProcessPage />,
  },
  {
    path: ROUTES.SEALED_VINYL_RESULT,
    element: <SealedVinylResultPage />,
  },
  {
    path: ROUTES.SEALED_VINYL_CARD_REGISTER,
    element: <CardRegisterPage />,
  },
  {
    path: ROUTES.SEALED_VINYL_CARD_REGISTER_CALLBACK,
    element: <CardRegisterCallbackPage />,
  },
])

export default router
